import jQuery from "jquery";
import mfaEvents from "../mfa/events/MFAEvents";
import AccessibilityUtil from "core-ui/client/src/app/core/util/AccessibilityUtil";

var OneIdMfaController = function ($scope, $location, $window,
    PrimaryPlanSelectionFactory, redirectService, eventBus, $translate,
    $cookies, SetACCUService, OneIdMfaFactory, accountService, $state, profileFactory, LinkedConfirmationFactory, DefaultCustomizationRetrService, PreLoginAccuRetrievalService, ReSetACCUService, $q, AccuCodeService, $rootScope, PreLoginContactInfoService, $timeout, mfaFactory) {
    var vm = this;
    vm.loading = true;
    vm.error = false;
    var deferred = $q.defer();
    $scope.mfa = {};
    $scope.activationCodeModel = {};
    $scope.internationalPhoneMessage = null;
    $scope.emptyDeliveryOptionsMessage = null;

    vm.noCodeReceived = function () {
        vm.loading = true;

    };

    vm.dataForOneIdMFAValidateCode = function () {
        var plansFromCurrentContext = [];
        angular.forEach($rootScope.plansMapWithIndIdDbName, function (values, key) {
            if (key === $rootScope.linkingContext) {
                angular.forEach(values, function (value) {
                    plansFromCurrentContext.push(value)

                });
            }

        });
        $rootScope.plansFromCurrentContext = plansFromCurrentContext;
    }
    vm.dataForOneIdMFAValidateCode();

    vm.getFormGroupClass = function (fieldName) {
        var field = $scope.oneIdVerificationForm[fieldName];
        var status = '';

        if (field.$invalid && field.$dirty) {
            status = 'has-error';
        }

        if (field.$invalid && $scope.oneIdVerificationForm.$submitted) {
            status = 'has-error';
        }

        return status;
    };

    vm.displayFieldError = function (fieldName) {
        var field = $scope.oneIdVerificationForm[fieldName];
        var displayFieldError = false;

        if (field.$invalid && field.$dirty) {
            displayFieldError = true;
        }

        if (field.$invalid && $scope.oneIdVerificationForm.$submitted) {
            displayFieldError = true;
        }

        return displayFieldError;
    };

    vm.getFieldError = function (fieldName) {
        return $scope.oneIdVerificationForm[fieldName].$error;
    };

    vm.validateOneIdMFACode = function (flowName) {

        $scope.showSpinner = true;
        // Check if the form input is valid
        if ($scope.oneIdVerificationForm.$valid) {

            var verificationData = {
                "verificationCode": $scope.verification.verificationCode,
                "indIdDbName": $rootScope.linkingContext
            };

            OneIdMfaFactory.validateOneIdMFACode.query(verificationData,

                function (data, headers) {
                    $scope.showSpinner = true;
                    if (data.errors === false) {
                        $scope.mfa.errorMessage = '';
                        $state.go('linkablePlans');


                    } else {
                        $scope.verificationMessage = data.activationCode;
                        $scope.showSpinner = true;
                    }

                },
                function (response) {
                    $scope.showSpinner = false;
                    $scope.mfa.errorMessage = '';
                    $scope.verificationMessage = "";

                    if (response.headers('exception') !== null) {
                        $scope.mfa.errorMessage = response.data.error.code;
                        $scope.mfa.errorMessageParams = response.data.error.errors[0];

                    } else {
                        $scope.mfa.errorMessage = '99999';

                    }
                });
        } else {
            $scope.showSpinner = false;
            // focus the error message for screen readers
            AccessibilityUtil.focusElement('screenReader');
        }
    };

    vm.getDeliveryOptions = function () {
        var firstPlan = getFirstPlanFromCurrentContext();
        var getDeliveryOptionsParam = { "indId": firstPlan.indId, "dbName": firstPlan.dbname };
        OneIdMfaFactory.getDeliveryOptions.query(getDeliveryOptionsParam,
            //success
            function (data, headers) {
                console.log('OneIdMfaController getDeliveryOptions success');
                console.log(data);
                $scope.authentication.flowName = data.flowName;
                $scope.mfa = data;
                $scope.mfa.errorMessage = null;

                var hasIntlPhoneNumber = false;
                if (headers('exception') !== null) {
                    $scope.mfa.errorMessage = headers('exception');
                } else {
                    if (data.destination == 'emptyDeliveryOptions') {
                        $scope.emptyDeliveryOptionsMessage = "We are unable to complete your request. If you require immediate account access please contact a Participant Services Representative.";
                        $state.go('oneIdMfaActivationCode');
                    } else if (!data.intlPhoneSupportAllowed) {

                        for (var i = 0; i < data.deliverySet.length; i++) {
                            if (data.deliverySet[i].deliveryPhoneType === 'IntlPhoneNumber') {
                                hasIntlPhoneNumber = true;
                                $scope.internationalPhoneMessage = "International phone number support is currently unavailable.";
                                $state.go('oneIdMfaActivationCode');
                            }
                        }
                        if (!hasIntlPhoneNumber) {
                            data.destination = 'mfa';
                        }

                    } else {
                        data.destination = 'mfa';
                    }
                    $scope.mfa.dataLoaded = true;
                    //set focus on deliveryOption element
                    $timeout(function () {
                        jQuery('#deliveryOption').focus();
                    }, 200);
                }
            }, //When it fails
            function (response) {
                $scope.mfa.errorMessage = '';
                if (response.headers('exception') !== null) {

                    $scope.mfa.errorMessage = response.data.error.code;
                    $scope.mfa.errorMessageParams = response.data.error.errors[0];
                } else {

                    $scope.mfa.errorMessage = '99999';
                }
            }
        ); //End of query function


    }; //End of getDeliveryOptions function

    vm.verifyCode = function () {
        eventBus.dispatch(mfaEvents.VERIFY_CODE, this);
        vm.loading = true;
        $state.go('oneIdMfaEnterCode');
    };

    vm.createAndDeliverActivationCodePOST = function (functionName) {
        // based on MFAController, with modifications
        eventBus.dispatch(mfaEvents.SEND_CODE, this);
        $scope.showSpinner = true;

        var firstPlan = getFirstPlanFromCurrentContext();
        var mfaRequestData = {
            "accu": $scope.accu,
            "deliveryOption": $scope.activationCodeModel.deliveryOption,
            "indid": firstPlan.indId,
            "dbName": firstPlan.dbname,
            "gaId": firstPlan.gaId
        };

        if ($scope.activationCodeModel.deliveryOption === 'none') {
            $scope.mfa.errorMessage = 'ActivationCodeDeliveryMissingInputException';
            handleScreenReader();
            $scope.showSpinner = false;
        } else {
            OneIdMfaFactory.createAndDeliverActivationCodePOST.query(
                mfaRequestData,
                // success
                function (data, headers) {
                    $scope.showSpinner = false;

                    if (headers('exception') !== null) {
                        $scope.mfa.errorMessage = headers('exception');
                        handleScreenReader();
                    } else {
                        $state.go('oneIdMfaEnterCode');
                    }
                }, // When it fails
                function (response) {
                    $scope.showSpinner = false;
                    if (response.headers('exception') !== null) {
                        $scope.mfa.errorMessage = response.data.error.code;
                        $scope.mfa.errorMessageParams = response.data.error.errors[0];
                        handleScreenReader();
                    } else {
                        $scope.mfa.errorMessage = '99999';
                        handleScreenReader();
                    }
                }); // End of query function

        }
    }; // End of createAndSendActivationCodePOST function

    var handleScreenReader = function () {
        AccessibilityUtil.focusElement('screenReader');
    };

    var getFirstPlanFromCurrentContext = function () {
        var plansFromCurrentContext = $rootScope.plansFromCurrentContext

        if (plansFromCurrentContext === null || plansFromCurrentContext.length == 0)
            return null;

        var firstPlan = plansFromCurrentContext[0];
        return firstPlan;
    }

    // focus the input with an error
    vm.focusOnErrorInput = function (e, elementId) {
        AccessibilityUtil.focusOnErrorInput(e, elementId);
    };
};

OneIdMfaController.$inject = ['$scope', '$location', '$window',
    'PrimaryPlanSelectionFactory', 'redirectService', 'eventBus',
    '$translate', '$cookies', 'SetACCUService', 'OneIdMfaFactory', 'accountService', '$state', 'profileFactory', 'LinkedConfirmationFactory', 'DefaultCustomizationRetrService', 'PreLoginAccuRetrievalService', 'ReSetACCUService', '$q', 'AccuCodeService', '$rootScope', 'PreLoginContactInfoService', '$timeout', 'mfaFactory'];
export default OneIdMfaController;
